/**
 * Quyền gì
 */
export default {
  View: 'View',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  Export: 'Export',
};
